module.exports = "https://99designs-start-assets.imgix.net/js/653abf8d3a56a24c4992e7b56644c6c3.jpg";